export enum CoordinationStatusEnum {
    COORDINATION_UNKNOWN = 'COORDINATION_UNKNOWN',
    COORDINATION_CREATED = 'COORDINATION_CREATED',
    COORDINATION_REMOVED = 'COORDINATION_REMOVED',
    COORDINATION_PENDING_ACCEPTANCE = 'COORDINATION_PENDING_ACCEPTANCE',
    COORDINATION_PENDING_REVIEW = 'COORDINATION_PENDING_REVIEW',
    COORDINATION_APPROVED = 'COORDINATION_APPROVED',
    COORDINATION_COORDINATED = 'COORDINATION_COORDINATED',
    COORDINATION_ACTIVATED = 'COORDINATION_ACTIVATED',
    COORDINATION_DEACTIVATED = 'COORDINATION_DEACTIVATED',
    COORDINATION_FINISHED = 'COORDINATION_FINISHED',
    COORDINATION_CANCELLING = 'COORDINATION_CANCELLING',
    COORDINATION_CANCELLED = 'COORDINATION_CANCELLED',
    COORDINATION_SUSPENDING = 'COORDINATION_SUSPENDING',
    COORDINATION_SUSPENDED = 'COORDINATION_SUSPENDED',
    COORDINATION_REJECTED = 'COORDINATION_REJECTED',
    COORDINATION_UNDERTEST = 'COORDINATION_UNDERTEST',
}